export default __webpack_public_path__ + "static/media/317.2b883d01.png";